var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-screen',{staticClass:"screen-welcome",attrs:{"title":"Welcome"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [(_vm.current === 1)?_c('app-button',{attrs:{"text":_vm.texts.ob.rules.button},on:{"click":_vm.onProceedClick}}):_vm._e()]},proxy:true}])},[(_vm.current === 1)?_c('com-rules'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }